import React, { useEffect, useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { logout, onAuthChange } from '../../services/authService';
import ConfirmActionModal from '../common/ConfirmActionModal';
import './AdminLayout.css';

const AdminLayout = ({ children }) => {
  const navigate = useNavigate();
  const [isAdmin, setIsAdmin] = useState(false);
  const [menuAbierto, setMenuAbierto] = useState(false);
  const [showConfirmModal, setShowConfirmModal] = useState(false);

  useEffect(() => {

    const sessionData = sessionStorage.getItem('usuario');
    if (!sessionData) {
      navigate('/login');
      return;
    }
    
    const usuario = JSON.parse(sessionData);
    if (usuario.type !== 'admin') {
      navigate('/login');
      return;
    }
    
    setIsAdmin(true);
    
    // Auth
    const unsubscribe = onAuthChange((user) => {
      if (!user) {
        sessionStorage.removeItem('usuario');
        navigate('/login');
      }
    });
    
    return () => unsubscribe();
  }, [navigate]);

  const handleLogoutClick = () => {
    setShowConfirmModal(true);
  };

  const handleConfirmLogout = async () => {
    await logout();
    setShowConfirmModal(false);
    navigate('/');
  };

  const handleCancelLogout = () => {
    setShowConfirmModal(false);
  };

  const toggleMenu = () => {
    setMenuAbierto(!menuAbierto);
  };

  if (!isAdmin) {
    return <div className="loading">Verificando acceso...</div>;
  }

  return (
    <div className="admin-layout">
      {}
      <header className="admin-header-mobile">
        <div className="admin-header-mobile-container">
          <div className="admin-logo">
            <h1>Golden Cars Legal</h1>
            <span className="admin-badge">Administrador</span>
          </div>
          <button className="menu-hamburguesa" onClick={toggleMenu}>
            <span className="hamburguesa-linea"></span>
            <span className="hamburguesa-linea"></span>
            <span className="hamburguesa-linea"></span>
          </button>
        </div>
        
        {}
        <nav className={`admin-nav-mobile ${menuAbierto ? 'abierto' : ''}`}>
          <ul>
            <li><Link to="/dashboard" onClick={() => setMenuAbierto(false)}>Dashboard</Link></li>
            <li><Link to="/clientes" onClick={() => setMenuAbierto(false)}>Clientes</Link></li>
            <li><Link to="/casos" onClick={() => setMenuAbierto(false)}>Casos</Link></li>
            <li><Link to="/admin/articulos" onClick={() => setMenuAbierto(false)}>Blog</Link></li>
            <li><Link to="/admin/solicitudes" onClick={() => setMenuAbierto(false)}>Solicitudes</Link></li>
            <li>
              <button onClick={handleLogoutClick} className="btn-logout-admin-mobile">
                Cerrar Sesión
              </button>
            </li>
          </ul>
        </nav>
      </header>

      {}
      <header className="admin-header-desktop">
        <div className="admin-header-container">
          <div className="admin-logo">
            <h1>Golden Cars Legal</h1>
            <span className="admin-badge">Administrador</span>
          </div>
          <nav className="admin-nav-desktop">
            <ul>
              <li><Link to="/dashboard">Dashboard</Link></li>
              <li><Link to="/clientes">Clientes</Link></li>
              <li><Link to="/casos">Casos</Link></li>
              <li><Link to="/admin/articulos">Blog</Link></li>
              <li><Link to="/admin/solicitudes">Solicitudes</Link></li>
              <li>
                <button onClick={handleLogoutClick} className="btn-logout-admin">
                  Cerrar Sesión
                </button>
              </li>
            </ul>
          </nav>
        </div>
      </header>

      <main className="admin-main">
        {children}
      </main>

      <footer className="admin-footer">
        <p>Golden Cars Legal - Panel de Administración</p>
      </footer>

      {}
      <ConfirmActionModal
        isOpen={showConfirmModal}
        onClose={handleCancelLogout}
        onConfirm={handleConfirmLogout}
        title="Cerrar Sesión"
        message="¿Estás seguro de que deseas cerrar sesión? Perderás el acceso al panel de administración."
        confirmText="Sí, cerrar sesión"
        cancelText="Cancelar"
      />
    </div>
  );
};

export default AdminLayout;